module.exports = __webpack_public_path__ + "img/player_jump_006.0dc7022b.png";